import { render, staticRenderFns } from "./photo-gallery.vue?vue&type=template&id=12ee1921&scoped=true"
import script from "./photo-gallery.vue?vue&type=script&lang=js"
export * from "./photo-gallery.vue?vue&type=script&lang=js"
import style0 from "./photo-gallery.vue?vue&type=style&index=0&id=12ee1921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee1921",
  null
  
)

export default component.exports